export default __webpack_public_path__ + "static/media/petal_s5.0cccec0e.svg";